export default __webpack_public_path__ + "static/media/video-light.9ed693bd.svg";